export const introduce = {
  text: '非零地址量统计了区块链网络中，持有coin大于0的地址数量（过滤重复地址）。',
  height: 1200,
};
